<template>
  <div class="app-page box-card">

    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">
          <el-form-item label="状态">
            <template slot="label">
              <I18Lang id="my79" defaultText="状态" />
            </template>
            <el-select v-model="queryForm.auth_status" :placeholder="$t('public17')">
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option v-for="(item, key) in statusList" :label="item" :value="key" :key="key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出金时间">
            <template slot="label">
              <I18Lang id="my108" defaultText="出金时间" />
            </template>
            <el-date-picker v-model="queryDate" type="daterange" @change="dateChange" value-format="yyyy-MM-dd"
              range-separator="-" :start-placeholder="$t('public22')" :end-placeholder="$t('public23')"></el-date-picker>
          </el-form-item>

          <div class="btn kg-btn2" @click="resetQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
        </el-form>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column width="180" label="流水号" prop="stream_no">
            <template slot="header">
              <I18Lang id="my66" defaultText="流水号" />
            </template>
          </el-table-column>

          <el-table-column width="180" label="出金金额($)" prop="amount_usd">
            <template slot="header">
              <I18Lang id="my112" defaultText="出金金额($)" />
            </template>
          </el-table-column>

          <el-table-column width="180" label="出金汇率" prop="exchange_rate">
            <template slot="header">
              <I18Lang id="my113" defaultText="出金汇率" />
            </template>
          </el-table-column>

          <el-table-column width="180" :label="`${$t('my111', { n: currMarket })}`" prop="amount_local">
          </el-table-column>

          <el-table-column width="180" label="操作后账户余额(MEQ)" prop="cash_balance">
            <template slot="header">
              <I18Lang id="recordAfterBalance" defaultText="操作后账户余额(MEQ)" />
            </template>
          </el-table-column>
          <el-table-column width="180" label="出金时间" prop="create_time">
            <template slot="header">
              <I18Lang id="my108" defaultText="出金时间" />
            </template>
          </el-table-column>
          <el-table-column label="审批备注">
            <template slot="header">
              <I18Lang id="my94" defaultText="审批备注" />
            </template>
            <template slot-scope="scope">
              {{ scope.row.auth_remark }}
            </template>
          </el-table-column>
          <el-table-column width="180" label="状态">
            <template slot="header">
              <I18Lang id="my79" defaultText="状态" />
            </template>
            <template slot-scope="scope">
              <StatusText :status="scope.row.auth_status" :text="statusList[scope.row.auth_status]" />
            </template>
          </el-table-column>

          <el-table-column label="操作" prop="name">
            <template slot="header">
              <I18Lang id="my96" defaultText="操作" />
            </template>
            <template slot-scope="scope">
              <div class="operat-group">
                <span class="operat-item btn-query" @click="lookInfo(scope.row)"></span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="`${$t('my97')}（${currentData.stream_no}）`" :visible.sync="dialog.preview" width="30%"
      :close-on-click-modal="false" :close-on-press-escape="false" class="info-dialog">
      <el-descriptions :colon="false" :column="1">
        <el-descriptions-item label="出金金额(本地货币)">
          <template slot="label">
            <I18Lang id="my111" :data="{ n: currMarket }" defaultText="出金金额（本地货币）" />
          </template>
          {{ currentData.amount_local }}
        </el-descriptions-item>
        <el-descriptions-item label="出金金额($)">
          <template slot="label">
            <I18Lang id="my112" defaultText="出金金额($)" />
          </template>
          {{ currentData.amount_usd }}
        </el-descriptions-item>
        <el-descriptions-item label="出金汇率">
          <template slot="label">
            <I18Lang id="public81" defaultText="出金汇率" />
          </template>
          {{ currentData.exchange_rate }}
        </el-descriptions-item>
        <el-descriptions-item label="操作后账户余额(MEQ)">
          <template slot="label">
            <I18Lang id="recordAfterBalance" defaultText="操作后账户余额(MEQ)" />
          </template>
          {{ currentData.cash_balance }}
        </el-descriptions-item>
        <el-descriptions-item label="出金时间">
          <template slot="label">
            <I18Lang id="my108" defaultText="出金时间" />
          </template>
          {{ currentData.create_time }}
        </el-descriptions-item>
         <el-descriptions-item label="钱包类型">
            <template slot="label">
              <I18Lang id="text60" defaultText="钱包类型" />
            </template>
            {{ currentData.wallet_type }}
          </el-descriptions-item>

          <el-descriptions-item label="钱包地址">
            <template slot="label">
              <I18Lang id="text59" defaultText="钱包地址" />
            </template>
            {{ currentData.wallet_address }}
          </el-descriptions-item>
        <el-descriptions-item label="审批备注">
          <template slot="label">
            <I18Lang id="my94" defaultText="审批备注" />
          </template>
          {{ currentData.auth_remark }}
        </el-descriptions-item>
        <el-descriptions-item label="审批状态">
          <template slot="label">
            <I18Lang id="my79" defaultText="状态" />
          </template>
          {{ statusList[currentData.auth_status] }}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <div class="btn kg-btn2" @click="dialog.preview = false">
          <I18Lang id="my98" defaultText="关闭" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { fileDomain } from '@utils'
import { mapState } from 'vuex'
import StatusText from '../../../components/StatusText'
import { auditStatusList } from '@utils/global'
export default {
  name: 'record',
  data () {
    return {
      fileDomain,
      dialog: {
        preview: false // 预览图片
      },
      queryDate: '',
      queryForm: {
        start_time: '',
        end_time: '',
        auth_status: '',
        page: '',
        size: ''
      },
      statusList: auditStatusList,
      currentData: {},
      tableData: {
        list: [],
        total: 0
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'currMarket'])
  },
  created () {
    this.getRecord()
  },
  methods: {
    getRecord () {
      this.$http
        .post('/api/cash/withdrawalRecords', this.queryForm)
        .then((result) => {
          console.log('result', result)
          this.tableData = result
        })
    },
    resetQuery () {
      this.queryForm.page = 1
      this.getRecord()
    },
    dateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    lookInfo (item) {
      // 查看凭证
      this.currentData = item
      this.dialog.preview = true
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  },
  components: {
    StatusText
  }
}
</script>
<style scoped lang="scss"></style>
